import React from 'react';
import { ShieldX } from 'lucide-react';

const Unauthorized = ({ onNavigateHome }) => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '60vh',
      textAlign: 'center',
      padding: '2rem',
    }}>
      <ShieldX
        style={{ color: '#ef4444', marginBottom: '1.5rem' }}
        size={72}
        strokeWidth={1.5}
      />
      <h1 style={{
        fontSize: '2rem',
        fontWeight: '700',
        color: '#111827',
        marginBottom: '0.75rem',
      }}>
        Access Denied
      </h1>
      <p style={{
        fontSize: '1rem',
        color: '#6b7280',
        maxWidth: '400px',
        lineHeight: '1.6',
        marginBottom: '2rem',
      }}>
        You don't have permission to view this page. Contact your administrator
        if you believe this is a mistake.
      </p>
      <button
        onClick={() => onNavigateHome('dashboard')}
        style={{
          padding: '0.75rem 2rem',
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          border: 'none',
          borderRadius: '0.5rem',
          fontSize: '1rem',
          fontWeight: '600',
          cursor: 'pointer',
          transition: 'opacity 0.2s ease',
        }}
        onMouseEnter={(e) => { e.currentTarget.style.opacity = '0.85'; }}
        onMouseLeave={(e) => { e.currentTarget.style.opacity = '1'; }}
      >
        Back to Dashboard
      </button>
    </div>
  );
};

export default Unauthorized;
